import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { AuthService } from '../../../services/auth/auth.service';
// To enable Chart.js integration: install `chart.js` and `ng2-charts` and then
// uncomment the imports below and the example properties further down.
// npm install chart.js ng2-charts
// import { NgChartsModule } from 'ng2-charts';
// import { ChartConfiguration, ChartData, ChartOptions } from 'chart.js';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent {
  public username: string | 'utilisateur' | undefined;
  cardsData = [
    {
      title: 'Marchés actifs',
      chiffres: 24,
      icon: 'trending_up',
      bgGradient: '135deg, #0f766e, #14b8a6',
      class: 'bg-gradient-cosmic',
      textDark: false,
      delta: '+2.5% from last week'
    },
    {
      title: 'Utilisateurs',
      chiffres: 132,
      icon: 'groups',
      bgGradient: '135deg, #1e3a8a, #3b82f6',
      class: 'bg-gradient-ibiza',
      textDark: false,
      delta: '+5.4% from last week'
    },
    {
      title: 'Transactions',
      chiffres: 541,
      icon: 'receipt_long',
      bgGradient: '135deg, #7c2d12, #f97316',
      class: 'bg-gradient-ohhappiness',
      textDark: false,
      delta: '-4.5% from last week'
    },
    {
      title: 'Alertes',
      chiffres: 3,
      icon: 'warning',
      bgGradient: '135deg, #7f1d1d, #ef4444',
      class: 'bg-gradient-kyoto',
      textDark: true,
      delta: '+8.4% from last week'
    }
  ];

  // Transposed from React `stats`
  stats = [
    { title: 'Utilisateurs actifs', value: 248, change: 12, changeLabel: 'vs mois dernier', icon: 'groups', trend: 'up' },
    { title: 'Projets en cours', value: 32, change: 4, changeLabel: 'nouveaux ce mois', icon: 'folder', trend: 'up' },
    { title: 'Tâches complétées', value: 156, change: 23, changeLabel: 'cette semaine', icon: 'check_box', trend: 'up' },
    { title: 'Taux de complétion', value: '78%', change: -5, changeLabel: 'vs semaine dernière', icon: 'trending_up', trend: 'down' },
  ];

  recentTasks = [
    { id: '1', title: 'Réviser la documentation API', project: 'Projet Alpha', status: 'in_progress', priority: 'high', dueDate: '2024-02-05' },
    { id: '2', title: 'Intégration module paiement', project: 'E-commerce', status: 'todo', priority: 'urgent', dueDate: '2024-02-03' },
    { id: '3', title: 'Tests unitaires composants', project: 'Projet Alpha', status: 'in_progress', priority: 'medium', dueDate: '2024-02-07' },
    { id: '4', title: "Design page d'accueil", project: 'Site vitrine', status: 'done', priority: 'low', dueDate: '2024-02-01' },
    { id: '5', title: 'Optimisation performances', project: 'Dashboard', status: 'todo', priority: 'high', dueDate: '2024-02-10' },
  ];

  activeProjects = [
    { id: '1', name: 'Projet Alpha', progress: 75, tasksCompleted: 15, totalTasks: 20, dueDate: '2024-03-15' },
    { id: '2', name: 'E-commerce Platform', progress: 45, tasksCompleted: 9, totalTasks: 20, dueDate: '2024-04-01' },
    { id: '3', name: 'Application Mobile', progress: 30, tasksCompleted: 6, totalTasks: 20, dueDate: '2024-05-01' },
    { id: '4', name: 'Dashboard Analytics', progress: 90, tasksCompleted: 18, totalTasks: 20, dueDate: '2024-02-28' },
  ];

  statusColors: Record<string, string> = {
    todo: 'badge-muted',
    in_progress: 'badge-blue',
    done: 'badge-green',
  };

  priorityColors: Record<string, string> = {
    low: 'badge-low',
    medium: 'badge-medium',
    high: 'badge-high',
    urgent: 'badge-urgent',
  };

  statusLabels: Record<string, string> = {
    todo: 'À faire',
    in_progress: 'En cours',
    done: 'Terminé',
  };

  priorityLabels: Record<string, string> = {
    low: 'Basse',
    medium: 'Moyenne',
    high: 'Haute',
    urgent: 'Urgente',
  };

  // Budget categories (from external React component)
  budgetCategories = [
    { name: 'Marketing', spent: 12400, allocated: 15000 },
    { name: 'Engineering', spent: 34200, allocated: 40000 },
    { name: 'Operations', spent: 8900, allocated: 10000 },
    { name: 'Sales', spent: 6700, allocated: 8000 },
    { name: 'HR & Admin', spent: 4800, allocated: 5000 },
  ];

  transactions = [
    { id: '1', description: 'Google Ads Campaign', category: 'Marketing', amount: 2340, type: 'expense', date: 'Feb 10, 2026', status: 'completed' },
    { id: '2', description: 'Client Payment - Acme Co', category: 'Revenue', amount: 15000, type: 'income', date: 'Feb 9, 2026', status: 'completed' },
    { id: '3', description: 'AWS Infrastructure', category: 'Engineering', amount: 4200, type: 'expense', date: 'Feb 8, 2026', status: 'completed' },
    { id: '4', description: 'Office Supplies', category: 'Operations', amount: 380, type: 'expense', date: 'Feb 7, 2026', status: 'pending' },
    { id: '5', description: 'Freelancer Payment', category: 'Engineering', amount: 3500, type: 'expense', date: 'Feb 6, 2026', status: 'completed' },
    { id: '6', description: 'Subscription Revenue', category: 'Revenue', amount: 8400, type: 'income', date: 'Feb 5, 2026', status: 'completed' },
  ];



  constructor(private authService: AuthService) {
    this.username = this.authService.getUsername();
  }

  /* Chart.js example data (disabled until dependencies are installed)
  public salesData = { labels: ['Jan','Feb','Mar'], datasets: [{ data: [65,59,80], label: 'Ventes' }] };
  public salesOptions = { responsive: true };

  public categoriesData = { labels: ['A','B','C'], datasets: [{ data: [45,25,30] }] };
  public productViewsData = { labels: ['P1','P2'], datasets: [{ data: [50,75] }] };
  */
}
